import {
  Context,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { ConnectWalletModal } from "./ConnectWalletModal/ConnectWalletModal";

export interface WalletState {
  selectedEvmWallet: string | null;
  selectedCosmosWallet: string | null;
  selectedAptosWallet: string | null;
  selectedSolanaWallet: string | null;
  openWalletModal: () => void;
  closeWalletModal: () => void;
  isWalletModalOpen: boolean;
}

const WalletContext: Context<WalletState> = createContext<WalletState>(
  {} as WalletState,
);

interface WalletProviderProps {
  children: any;
}
export const WalletProvider = ({ children }: WalletProviderProps) => {
  const [selectedEvmWallet, setSelectedEvmWallet] = useState(
    localStorage.getItem("lastEvmConnector"),
  );
  const [selectedCosmosWallet, setSelectedCosmosWallet] = useState(
    localStorage.getItem("lastCosmosConnector"),
  );
  const [selectedAptosWallet, setSelectedAptosWallet] = useState(
    localStorage.getItem("lastAptosConnector"),
  );
  const [selectedSolanaWallet, setSelectedSolanaWallet] = useState(
    // SolanaWalletProvider manages Solana localStorage item.
    // It adds quotes at the beginning and the end.
    // We must remove them to correctly map the wallet name in the app.
    localStorage.getItem("lastSolanaConnector")?.slice(1, -1) || null,
  );

  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const closeWalletModal = useCallback(() => {
    setIsWalletModalOpen(false);
  }, []);
  const openWalletModal = useCallback(() => {
    setIsWalletModalOpen(true);
  }, []);

  const state = useMemo<WalletState>(
    () => ({
      selectedEvmWallet,
      selectedCosmosWallet,
      selectedAptosWallet,
      selectedSolanaWallet,
      openWalletModal,
      closeWalletModal,
      isWalletModalOpen,
    }),
    [
      selectedEvmWallet,
      selectedCosmosWallet,
      selectedAptosWallet,
      selectedSolanaWallet,
      openWalletModal,
      closeWalletModal,
      isWalletModalOpen,
    ],
  );

  return (
    <WalletContext.Provider value={state}>
      <ConnectWalletModal
        isOpen={isWalletModalOpen}
        onCloseClick={closeWalletModal}
        setSelectedEvmWallet={setSelectedEvmWallet}
        setSelectedCosmosWallet={setSelectedCosmosWallet}
        setSelectedAptosWallet={setSelectedAptosWallet}
        setSelectedSolanaWallet={setSelectedSolanaWallet}
      />
      {children}
    </WalletContext.Provider>
  );
};

export function useWallet(): WalletState {
  return useContext(WalletContext);
}
